"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ defaults, palette, typography }) => ({
    root: {
        position: 'relative',
        zIndex: 0,
        minWidth: defaults.content.pageMinWidth,
        backgroundColor: palette.background.default,
    },
    header: {
        minHeight: defaults.headers.headerHeight,
        borderBottom: `1px solid ${palette.border.dark}`,
        backgroundColor: palette.background.paper,
        zIndex: 2,
    },
    headerContent: {
        width: '100%',
        paddingLeft: defaults.content.paddingLeftMobile,
        paddingRight: defaults.content.paddingRightMobile,
        '@media (min-width: 769px)': {
            paddingLeft: defaults.content.paddingLeft,
            paddingRight: defaults.content.paddingRight,
        },
        minHeight: defaults.headers.headerHeight,
    },
    pathButton: Object.assign(Object.assign({}, typography.body2), { background: 'transparent', border: 'none', outline: 0, color: palette.primary.main, textTransform: 'none', minWidth: 10, marginTop: 7, padding: 0, cursor: 'pointer', '&:disabled': {
            color: palette.text.primary,
        }, '&.isLastLeaf': {
            cursor: 'default',
        } }),
    pathDivider: Object.assign(Object.assign({}, typography.body2), { padding: '6px 6px 6px 5px' }),
});
exports.default = styles;
